import React from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from 'antd';

const num = (v) => Number(v || 0).toLocaleString('sr-RS');

const accountsText = (accounts = []) =>
  accounts.map((a) => `${a.accountCode} ${a.accountName} (${num(a.amount)})`).join(', ');

/**
 * Preview warnings: what the AOP engine could not place on its own (a
 * negative position, aktiva and pasiva apart) in the accountant's language,
 * anything else as the server worded it.
 *
 * @param {Object} props - Component props
 * @param {Array} props.warnings - validation.warnings from the preview
 * @param {string} [props.className] - Extra class
 * @returns {JSX.Element|null} The warning box, or nothing
 */
export default function AopFindingsAlert({ warnings, className }) {
  const { t } = useTranslation('tables');
  if (!warnings?.length) return null;

  const text = (w) => {
    const key = 'financialStatements.aopFindings';
    if (w.type === 'UNBALANCED') {
      return t(`${key}.unbalanced`, { gap: num(w.gap), year: t(`${key}.years.${w.year}`) });
    }
    if (w.type === 'NEGATIVE_AOP' && w.movedTo) {
      return t(`${key}.moved`, { aop: w.aopCode, amount: num(w.amount), to: w.movedTo, accounts: accountsText(w.accounts) });
    }
    if (w.type === 'NEGATIVE_AOP') {
      return t(`${key}.negative`, { aop: w.aopCode, amount: num(w.amount), accounts: accountsText(w.accounts) });
    }
    return w.message;
  };

  return (
    <Alert
      type="warning"
      showIcon
      className={className}
      message={t('financialStatements.validationWarnings')}
      description={
        <ul>
          {warnings.map((w, idx) => (
            <li key={idx}>{text(w)}</li>
          ))}
        </ul>
      }
    />
  );
}
